// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_m3-0";
export var animationContainer = "_m3-1";
export var itemPrice = "_m3-a";
export var itemizedContent = "_m3-9";
export var itemizedHeader = "_m3-7";
export var itemizedRow = "_m3-8";
export var itemizedSection = "_m3-6";
export var modalContent = "_m3-2";
export var orderName = "_m3-3";
export var refundOption = "_m3-4";
export var refundOptionsContainer = "_m3-5";
export var shippingLabel = "_m3-b";
export var totalRow = "_m3-c";